<template>
  <div class="flex flex-center printLayout" :class="{ 'full-screen': isFullScreenMode }">
    <div class="flex flex-column printLayout--wrapper">
      <div v-if="!isFullScreenMode" class="flex flex-align-items-center printLayout--header">
        <nuxt-link class="printLayout--header--link" to="/">
          <img src="/svg/logo/vz-logo.svg" height="17" alt="Логотип компании Vozovoz">
        </nuxt-link>
        <span class="printLayout--header--title">
          ПЕРЕВОЗКИ СБОРНЫХ ГРУЗОВ
        </span>
        <div class="printLayout--header--spacer" />
        <a href="/" class="text-bold printLayout--header--name">vozovoz.ru</a>
      </div>
      <div class="map-scheme">
        <client-only>
          <y-map
            v-if="terminal.coordinates"
            ref="ymap"
            :zoom=16
            :height="mapSchemeHeight"
            :coords="terminal.coordinates"
            :load-call-back="loadCallBack"
          />
          <template v-if="!isFullScreenMode" #fallback>
            <div :style="`height: ${height}px;`"></div>
          </template>
        </client-only>
        <vz-button
          v-if="!isFullScreenMode" 
          :to="fullScreenLink"
          icon-name="fullscreen"
          icon-size="20"
          target="_blank"
          variant="primary"
          class="map-scheme-link"
        >
          На весь экран
        </vz-button>
        <terminal-scheme v-if="!isFullScreenMode" :terminal="terminal" />
      </div>
    </div>
  </div>
  
</template>

<script setup lang="ts">
import YMap from '~/components/ui-kit/map/y-map.vue';
import ymapsType from 'yandex-maps';
import ymapsArrow from '~/components/forms/map/ymapsArrow';
import {getTerminal} from '~/api/city';
import TerminalScheme from '~/components/forms/map/terminal-scheme.vue';

definePageMeta({
  layout: 'empty',
})

const height = 450
const phone = '88007072002'
const route = useRoute()

const fullScreenLink = computed(() => {
  return { name: 'mapScheme', query: { g: route.query?.g, full: true } }
})

const isFullScreenMode = computed(() => {
  return !!route.query?.full
})

const mapSchemeHeight = computed(() => {
  return isFullScreenMode.value ? undefined : height
})

const terminal = await getTerminal(route.query.g?.toString() || '').then(response => {
  if (response.error) {
    showError({ statusMessage: response.error })
  }
  return response
})

function loadCallBack (module: typeof ymapsType, map: ymapsType.Map): void {
  if (process.client) {
    ymapsArrow(module)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    module.modules.require(['geoObject.Arrow'], (Arrow) => {
      JSON.parse(terminal.route).forEach((r: any) => {
        const arrow = new Arrow(r, null, {
          geodesic: true,
          strokeWidth: 2,
          strokeColor: 'ec1b22',
          strokeStyle: 'shortdash'
        })
        map.geoObjects.add(arrow)
      })
    })
    const marker = new module.Placemark(terminal.coordinates, {}, {
      // Опции.
      // Необходимо указать данный тип макета.
      iconLayout: 'default#image',
      // Своё изображение иконки метки.
      iconImageHref: '/svg/vz-geolocation-home-red.svg',
      // Размеры метки.
      iconImageSize: [28, 40]
    })
    map.geoObjects.add(marker)
  }
}
</script>

<style lang="scss" scoped>
.printLayout {
  &--wrapper {
    max-width: 800px;
    width: 100%;

    @media screen and (max-width: $lg) {
      max-width: 600px;
    }

    @media screen and (max-width: $sm) {
      max-width: none;
      width: calc(100% - 40px);
      margin-left: auto;
      margin-right: auto;
    }
  }

  &--header {
    border-bottom: 3px solid $primary;
    padding: 20px 0 12px;

    &--link {
      height: 17px;
      > img {
        vertical-align: unset;
      }
    }

    &--title {
      margin-left: 16px;
      font-size: $fs-14;
      line-height: 17px;
      white-space: nowrap;
      font-weight: 400;

      @media screen and (max-width: $sm) {
        display: none;
      }
    }

    &--name {
      color: $font-lower;
      font-size: 18px;
      line-height: 24px;
    }

    &--spacer {
      flex-basis: 100%;
    }

    @media screen and (max-width: $sm) {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .map-scheme {
    margin-top: 24px;
    width: 100%;
    height: 450px;
    position: relative;

    &-link {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  &.full-screen {
    .printLayout {
      &--wrapper {
        max-width: none;

        @media screen and (max-width: $sm) {
          width: 100%;
        }
      }
    }
    .map-scheme {
      margin-top: 0;
      height: 100vh !important;
    }
  }

  @media print {
    .map-scheme-link {
      display: none !important;
    }
  }
}
</style>
